define(function (require) {
    var $ = require("jquery");

    return function (MODULE_ID, defaultOptions, Methods, optionsDeepExtend) {

        var PREFIXED_OPTIONS = MODULE_ID + ".options";
        var PREFIXED_STATE = MODULE_ID + ".data"; 

        function fnOptions($that, val)
           {
                if (arguments.length === 1)
                {
                    return $that.data(PREFIXED_OPTIONS);
                }

                $that.data(PREFIXED_OPTIONS, val);
        };

        function fnState($that, val)
        {
                if (arguments.length === 1)
                {
                    return $that.data(PREFIXED_STATE);
                }

                $that.data(PREFIXED_STATE, val);
        };


        function setProperties($this) {
            //Set/get options like anywhere in the module : $this.options = ...
            //attention, si 2 quantamodules définis sur le meme element, risque que le get options du 1er renvoie les options du 2eme
 
            Object.defineProperty($this, "options", {
                get: function () { return fnOptions(this); },  //return this.data(MODULE_ID + ".options"); },
                set: function (value) { fnOptions(this, value); }   //this.data(MODULE_ID + ".options", value); }
            });

            //Stores variables that defines the state of the module
            Object.defineProperty($this, "state", {
                get: function () { return fnState(this); },    //return this.data(MODULE_ID + ".data"); },
                set: function (value) { fnState(this, value); } //this.data(MODULE_ID + ".data", value); }
            });
        }

        //objet leger qui encapsule l'instance jquery, 
        //mais permet d'acceder aux options bien prefixées du module
        //au lieu d'ecraser la propriété "options" ou "state" de l'instance jquery
        //cet objet est passé comme 2eme parametre de Methods($this, propHelper)
        function CPropHelper($that)
        {
            this.$instance = $that;
        }
        Object.defineProperty(CPropHelper.prototype, "options", {
            get: function () {
                return fnOptions(this.$instance);
            },
            set: function (val) {
                fnOptions(this.$instance, val);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CPropHelper.prototype, "state", {
            get: function () {
                return fnState(this.$instance);
            },
            set: function (val) {
                fnState(this.$instance, val);
            },
            enumerable: true,
            configurable: true
        });
       
        

        return function (firstParameter) {
            if (firstParameter === "defaultOptions") return  defaultOptions;
            
            //this = array jQuery
            if (this.length == null || this.length == 0) return;
            

            //method call
			if (typeof firstParameter === "string") {
				var returnedValues = [];

				// on sauvegarde les args avant qu'ils soient écrasés dans le .each()
				var args = arguments;

				// call a method on each node
				this.each(function () {
					var $this = $(this);

					setProperties($this);

					var fnMethod = Methods($this, new CPropHelper($this))[firstParameter];
					if (fnMethod) {//If method exist
						var returnedValue = fnMethod.apply($this, Array.prototype.slice.call(args, 1))

						//toutes les fonctions qui ne retournent rien sont chainables (à la jQuery)
						if (returnedValue === undefined) {
							returnedValue = $this;
						}

						returnedValues.push(returnedValue);
					}
					else {
						console.log("Method `" + firstParameter + "` is not public (module `" + MODULE_ID + "`).")
					}
				});

				// if only one result, return it instead of an array
				if (returnedValues.length === 1 ) {
					return returnedValues[0];
				}

				return returnedValues;
            }
            else {//Initialisation
                
                //Les options par défault sont overridés par celles spécifiées
                var optionsDeepExtendFinal = (optionsDeepExtend != null && optionsDeepExtend === true);
                var options = $.extend(optionsDeepExtendFinal, {}, defaultOptions, firstParameter);

                //Call init on each node
                this.each(function () {
                    var $this = $(this);
                    setProperties($this);

                    //Init state as empty object
                    $this.state = {};
                    $this.options = $.extend(true, {}, options);//chacun sa copie !

                    if (firstParameter === undefined || typeof firstParameter === 'object') {
                        Methods($this, new CPropHelper($this)).init.call($this);
                    }
                    else if (typeof firstParameter === "function") {
                        Methods($this, new CPropHelper($this)).initWithMethod.call($this, firstParameter);
                    }
                    else {
                        //non géré (yet ?)
                    }
				});

				// pour pouvoir chainer à la jquery
				return this;
            }
        }
    }
});
